import { render, staticRenderFns } from "./PurchaseBonds.vue?vue&type=template&id=370b34ac&"
import script from "./PurchaseBonds.vue?vue&type=script&lang=js&"
export * from "./PurchaseBonds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports